import $ from "cash-dom";
import { arraysAreEqual } from "../utilities/toolkit";

const variantIamges = $('[data-element="variant-image"] img');

// attach event listeners for both selects and radio inputs
$('[data-element="product-option"], [data-element="product-option-radio"]').on(
	"change",
	function (e) {
		e.preventDefault();

		// find the nearest product form
		const form = $(e.target).closest('[data-component="product-form"]');
		const variant = calculateVariant(form);

		if (variant !== false) {
			// update the variant in the URL, hidden input, and price display
			updateVariantInURL(variant.id);
			updateVariantIdInForm(form, variant);
			updatePrice(form, variant);
			updateVariantImage(variant);
			// syncProductForms(form);
		}

		updateAddToCartButton(form, variant);
	},
);

const updateVariantImage = (variant) => {
	variantIamges.attr("srcset", "");
	variantIamges.attr("src", variant.featured_image.src);
};

const calculateVariant = (form) => {
	// find all select boxes
	const selects = form.find('[data-element="product-option"]');
	// find checked radio buttons
	const radios = form.find('[data-element="product-option-radio"]:checked');

	let values = [];
	let variants = window.Luna.product.variants;

	// gather selected values from dropdowns
	selects.each((i, el) => {
		values.push(decodeURIComponent(el.value));
	});

	// gather selected values from radio buttons (checked only)
	radios.each((i, el) => {
		values.push(decodeURIComponent(el.value));
	});

	// find the variant whose options array matches the selected values
	for (let i = 0; i < variants.length; i++) {
		if (arraysAreEqual(variants[i].options, values)) {
			return variants[i];
		}
	}

	// no matching variant found
	return false;
};

const updateVariantInURL = (variantId) => {
	const params = "?variant=" + variantId;
	window.history.replaceState({}, null, `${window.location.pathname}${params}`);
};

const updateVariantIdInForm = (form, variant) => {
	const idField = form.find('[name="id"]');
	idField.attr("value", variant.id);
};

const updateAddToCartButton = (form, variant) => {
	const button = form.find('[data-element="add-to-cart-button"]');
	button.attr("data-state", "");

	if (variant === false) {
		button.prop("disabled", true);
	} else {
		if (variant.available) {
			button.prop("disabled", false);
			button.attr("data-state", "");
		} else {
			// variant exists but is out of stock
			button.prop("disabled", true);
			button.attr("data-state", "out-of-stock");
		}
	}
};

const updatePrice = (form, variant) => {
	// update normal price
	const priceElements = $(document).find('[data-content="product-price"]');
	let formattedPrice = window.Luna.currency.format.replace(
		"{{amount}}",
		variant.price / 100,
	);
	priceElements.html(formattedPrice.replace(".00", ""));

	// update compare price
	const compareElements = form.find('[data-content="product-compare-price"]');
	// if there is no compare price
	if (!variant.compare_at_price) {
		// hide it
		compareElements.addClass("hidden");
		return;
	}

	if (variant.compare_at_price > variant.price) {
		compareElements.removeClass("hidden");
		formattedPrice = window.Luna.currency.format.replace(
			"{{amount}}",
			variant.compare_at_price / 100,
		);
		compareElements.html(formattedPrice.replace(".00", ""));
	}
};
